import { render, staticRenderFns } from "./UnsubscribeEmail.vue?vue&type=template&id=65b39783"
import script from "./UnsubscribeEmail.vue?vue&type=script&lang=js"
export * from "./UnsubscribeEmail.vue?vue&type=script&lang=js"
import style0 from "./UnsubscribeEmail.vue?vue&type=style&index=0&id=65b39783&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports